import { Field, FieldError, FieldLabel } from '@playbooks/ui/components/field'
import { QuestionData } from '@playbooks/action-cards-utils/src'
import MarkdownText from '../../../components/MarkdownText'
import Highlighter from '../components/Highlighter'
import { JSX, useState } from 'react'
import { InputProps } from '../types'
import { useAppContext } from '../../../contexts/AppContext'

export default function FieldWrapper({
  question,
  render,
  onChange,
}: {
  question: QuestionData
  render: (onChange: InputProps['onChange'], invalid?: boolean) => JSX.Element
  onChange: InputProps['onChange']
  isDocView?: boolean
}) {
  const {
    settings: { showMandatoryFields },
  } = useAppContext()
  const [errorMessageState, setErrorMessageState] = useState<string | null>(null)

  const handleChange = (value: unknown, errorMessage?: string) => {
    setErrorMessageState(errorMessage || null)

    if (!errorMessage) onChange(value)
  }

  const questionText = showMandatoryFields ? `${question.text}${question.required ? ' *' : ''}` : question.text

  return (
    <Field
      data-field-wrapper
      data-field-wrapper-error-message={errorMessageState}
      data-invalid={!!errorMessageState}
      className="AC_question relative gap-2"
      orientation="responsive"
    >
      <FieldLabel className="text-sm" htmlFor={`question-${question.id}`}>
        <MarkdownText text={questionText} />
      </FieldLabel>

      <Highlighter id={question.id}>
        <div className="w-full">{render(handleChange, !!errorMessageState)}</div>
      </Highlighter>

      {errorMessageState && <FieldError className="absolute -bottom-4 text-xs">{errorMessageState}</FieldError>}
    </Field>
  )
}
